import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner"; 
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root' 
})
 
export class NotifyService {
  public DASBOARD_URL = BASE_URL.URL; 
  private userId: any;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) { }

  getnotify(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/notifications?interval=daily`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this)) 
      ); 
  }

  getnotifyList(currentPage: number, status: Array<String> = [], raisedSortValue: String, store: Array<String> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');
    // let searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    return this.http.get(`${this.DASBOARD_URL}/notifications?interval=daily&page=${currentPage}${status.length > 0 ? `&status=${status}` : ''}${raisedSortValue ? `&updated_at=${raisedSortValue}` : ''}${store.length > 0 ? `&store_name=${store}` : ''}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getnotifyRead(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/notifications/read`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422){
      this.spinnerService.hide();
      return throwError(()=> error);
    }
    else{
      console.error('server error:', error);
    }

  }

}
